import { EnglishHeadline, GermanHeadline, Gallery } from "@components";
import React from 'react';
export default {
  EnglishHeadline,
  GermanHeadline,
  Gallery,
  React
};